import { AppConstants, UnitChart } from '@apps/app.constants';
import { ConvertService } from '@common/services/convert.service';
import { FlatItem } from './flat-item';

export class HistoricalSerie
{
    public channelId: number;
    public channel: string;
    public identifier: string;
    public min: number;
    public max: number;
    public unit: string;
    private _data: FlatItem[];

    get data (): FlatItem[]
    {
        return this._data;
    }
    set data (flatItem: FlatItem[])
    {
        const values: number[] = flatItem.map((fi: FlatItem) =>
            fi.rawValue
        );
        let result: { min: number, max: number, unit: string, power: number, indexUnit: number };

        this._data = [...flatItem];

        this.min = this.unit !== '%' ? Math.min(...values) : 0;
        this.max = this.unit !== '%' ? Math.max(...values) : 100;

        switch (this.unit)
        {
            case 'm':
                this.data.forEach((fi: FlatItem) =>
                    fi.rawValue /= 60
                );
                break;
            case 'd':
                this.data.forEach((fi: FlatItem) =>
                    fi.rawValue /= AppConstants.DayInSeconds
                );
                break;
            case 'MB':
                result = ConvertService.toIntelligentBytesUnits(this.min, this.max);

                this.data.forEach((fi: FlatItem) =>
                    fi.rawValue /= result.power
                );

                this.unit = result.unit;
                break;
        }
    }

    constructor (channelId: number, channel: string, unit: string)
    {
        this.channelId = channelId;
        this.channel = channel;
        this.unit = unit;

        this.identifier = `channel${channelId}`;
    }
}

export class HistoricalData
{
    unit: string;
    type: UnitChart = undefined;
    channelId: number;
    historicalSeries: HistoricalSerie[];

    constructor (unit: string)
    {
        this.unit = unit;
        switch (this.unit)
        {
            case 'm':
            case 'd':
            case 's':
                this.type = 'duration';
                break;
            case '#':
                this.type = 'counter';
                break;
            default:
                this.type = 'volume';
                break;
        }

        if (this.unit.startsWith('%'))
        {
            this.type = 'percentage';
        }
    }

    public myChannelId (): void
    {
        const channelIds: number[] = this.historicalSeries.map((hs: HistoricalSerie) =>
            hs.channelId
        );

        this.channelId = -1 * Math.min(...channelIds);
    }
}
